<template>
    <div id="Modal" v-show="modalShow" @click="close">
        <slot name="modal-content"></slot>
    </div>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            show: {
                type: Boolean
            }
        },
        data() {
            return {
                // modalShow: false
            }
        },
        methods: {
            close(e) {
                // console.log(e.target.id)
                if (e.target.id === 'Modal') {
                    this.$emit('close', false)
                }
            }
        },
        computed: {
            modalShow() {
                console.log(this.show)
                return this.show
            }
        }
        // watch: {
        //     registerShow(val) {
        //         this.modalShow = val
        //     }
        // }
    }
</script>

<style scoped lang="less">
    #Modal {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: fixed;
        background: rgba(0, 0, 0, .5);
        z-index: 300;

    }

</style>



// WEBPACK FOOTER //
// src/components/modal/Modal.vue